import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../../Shared/Common';
import MemsAPI from '../Shared/DataMemAPI';

import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';

import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { SSDComps, SSDMembers } from '../../../../Brands/SSD/Start'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose, faTable, faImage, faTrash } from '@fortawesome/free-solid-svg-icons';


export const Members_Home = (props) => {
    return (
        <SSDMembers>
            <Members_HomeContent />
        </SSDMembers>
    );
}   
export default Members_Home;

export const Members_HomeContent = (props) => {

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
    }, []);

    return (
        <Block name="MembersHome" isAlt={false}>

            <TextHeader
                text="Sans Souci Dolphins Membership Corner"
            />

            <TextTitle
                text="Login or Create an account to access your Membership, Events and much more..."
            />

            <Members_LogIn />

        </Block>
    );
}

export const Members_LogIn = (props) => {
    useEffect(() => {
    }, []);

    const [emailAddress, setEmailAddress] = useState("");

    let onEmailAddressChange = function (item, event) {
        setEmailAddress(item.target.value);
    };

    let loginClick = async () => {

    };

    return (
        <Fragment>
            <Fragment>

                <Row>
                    <Col lg="8" className="text-center">
                        <FormGroup>
                            <Input type="text" value={emailAddress} onChange={onEmailAddressChange} placeholder="Email Address" required />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col lg="8" className="text-right">
                        <Button color="success"> <FontAwesomeIcon icon={faImage} onClick={loginClick} />&nbsp;Sign In</Button> &nbsp;
                        <Button color="primary"> <FontAwesomeIcon icon={faTable} />&nbsp;Create Account</Button>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="footer-spacer">
                        </div>
                    </Col>
                </Row>
                
            </Fragment>

           
        </Fragment>
    );
}
